import React, { useEffect, useRef } from "react";
import Navbar from "../../Navigation/Navbar";
import Footer from "../../Footer/Footer";
import { useAnimation, useInView, motion } from "framer-motion";
import TeamImage from '../../../images/owner.jpeg';
// New icon imports
import { FaMoneyBill } from "react-icons/fa";
import { SlNote } from "react-icons/sl";
import { MdSettings } from "react-icons/md";

const skillsData = [
  {
    name: "Meilleurs prix",
    icon: (
      <FaMoneyBill className="text-5xl text-primary group-hover:text-black duration-300" />
    ),
    link: "#",
    description: "Profitez des meilleurs prix du marché pour des solutions solaires de haute qualité. Éclairez votre maison ou votre entreprise sans vous ruiner!",
    aosDelay: "0",
  },
  {
    name: "Faciles à installer",
    icon: (
      <MdSettings className="text-5xl text-primary group-hover:text-black duration-300" />
    ),
    link: "#",
    description: "Nos kits solaires sont faciles à installer et prêts à l’emploi en un rien de temps. Plus besoin d’attendre, bénéficiez immédiatement d’une énergie propre et durable !",
    aosDelay: "500",
  },
  {
    name: "Garantis de 24 mois",
    icon: (
      <SlNote className="text-5xl text-primary group-hover:text-black duration-500" />
    ),
    link: "#",
    description: "Nos produits sont conçus pour durer et sont garantis jusqu’à 24 mois. Optez pour la tranquillité d’esprit avec des équipements fiables et performants.",
    aosDelay: "1000",
  },
];

const About = () => {
    const ref = useRef();
    const isInView = useInView(ref);
    const mainControlls = useAnimation();
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    useEffect(() => {
      if (isInView) {
        mainControlls.start("visible");
      }
    }, [isInView, mainControlls]);
  return (
    <div>
      <Navbar />
      <div className="max-w-screen overflow-hidden font-poppins">
        <div className="min-h-screen bg-gradient-to-b from-gray-100/10 to-gray-200/50 pt-16">
          <div className="mt-20">
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: -75 },
                visible: { opacity: 1, y: 0 },
              }}
              initial="hidden"
              animate={mainControlls}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="flex justify-center text-center drop-shadow-lg"
            >
              <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-emerald-500 font-extrabold text-[3rem] border-b-4 border-blue-300 pb-2">
                Qui sommes-nous ?
              </h1>
            </motion.div>
            {/* Adjusted Image and Info Text Section */}
            <div className="sm:flex gap-12 items-center mx-10 my-10">
              <motion.div
                ref={ref}
                variants={{
                  hidden: { opacity: 0, x: -75 },
                  visible: { opacity: 1, x: 0 },
                }}
                initial="hidden"
                animate={mainControlls}
                transition={{ duration: 0.5, delay: 0.25 }}
                className="sm:w-1/2 w-full mb-8 sm:mb-0"
              >
                <img
                  alt="imageAbout"
                  src={TeamImage}
                  className="rounded-2xl shadow-lg sm:mx-auto object-cover hover:scale-105 transition-transform duration-300"
                />
              </motion.div>
              <motion.div
                ref={ref}
                variants={{
                  hidden: { opacity: 0, x: 75 },
                  visible: { opacity: 1, x: 0 },
                }}
                initial="hidden"
                animate={mainControlls}
                transition={{ duration: 0.5, delay: 0.25 }}
                className="sm:w-1/2 w-full flex flex-col justify-center p-4 space-y-6"
              >
                <p className="text-gray-700 text-base">
                  ETS ROSE est une entreprise engagée dans l'électrification durable à travers des solutions solaires innovantes et accessibles. Nous fournissons des produits et services solaires de haute qualité pour les ménages, ONG, services sociaux (écoles, hôpitaux), entreprises et coopératives.
                </p>
                <p className="text-gray-700 text-base">
                  Notre mission est simple : apporter la lumière et l’énergie à ceux qui en ont besoin, tout en réduisant l’empreinte carbone et en promouvant une énergie propre et renouvelable. Grâce à nos partenariats avec des experts du secteur et au respect des normes internationales, nous garantissons des solutions fiables, durables et adaptées à tous les besoins.
                </p>
              </motion.div>
            </div> {/* End of flex container with image and detailed info */}
            {/* New Services Section */}
            <div className="py-14 sm:min-h-[600px] sm:grid sm:place-items-center">
              <div className="container">
                <div className="pb-12">
                <h2 className="text-transparent text-center bg-clip-text bg-gradient-to-r from-blue-500 to-emerald-500 font-extrabold text-[3rem]  pb-2">
                Pourquoi nous choisir
              </h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  {skillsData.map((skill) => (
                    <div
                      key={skill.name}
                      data-aos="fade-up"
                      data-aos-delay={skill.aosDelay}
                      className="card text-center group space-y-3 sm:space-y-6 p-4 sm:py-16 bg-green-900 hover:bg-green-600 text-white hover:text-black rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
                    >
                      <div className="grid place-items-center">{skill.icon}</div>
                      <h1 className="text-2xl font-bold">{skill.name}</h1>
                      <p>{skill.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* End of Services Section */}
            {/* Improved Shops Addresses Section */}
            <div className="py-12 bg-gray-100">
              <div className="max-w-lg mx-auto px-6 py-8 bg-white rounded-xl shadow-lg border-t-4 border-blue-500">
                <h2 className="text-3xl font-extrabold text-center mb-6 text-gray-800">Nos Boutiques</h2>
                <p className="text-lg text-gray-600 text-center leading-relaxed">
                  Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA. Aux agences de l’UCODE-MF (Kirundo &amp; Muyinga) ; au point de vente devant la BCB KIRUNDO.
                </p>
              </div>
            </div>
            {/* End of Shops Addresses Section */}
          </div>
        </div>
        <div className="w-full h-[2px] bg-gradient-to-r from-blue-400 to-violet-500 my-8"></div>
        <div className="h-[22rem] sm:mt-20 mt-10 mb-20">
          <h1 className="flex justify-center font-extrabold text-center sm:text-4xl text-2xl pb-2">
          Où nous trouver
          </h1>
          <div className="flex justify-center mt-20" id="maps">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3909.7469026371896!2d30.090638723652283!3d-2.5860272667856083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sMARCHE%20DE%20Kriundo!5e0!3m2!1sen!2sbi!4v1742047571318!5m2!1sen!2sbi" 
              title="ETS Rose Location Map"
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade"
              className="w-full sm:mx-36 h-full rounded-lg shadow-lg border-2 border-gray-200"
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
